import * as svg from "../../../assets/chevron-right-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ChevronRightIcon = iconBuilder(svg, "ChevronRightIcon", "0 0 12 12");
